export const SET_LOCATION_DESCRIPTION = 'SET_LOCATION_DESCRIPTION';
export const SET_LOCATION_IMAGE = 'SET_LOCATION_IMAGE';
export const SET_SEARCH_QUERY_LOCATION = 'SET_SEARCH_QUERY_LOCATION';